import routes from '@modules/subproperty-settings/finantial-settings/finantial-settings-routes';
import store from '@modules/subproperty-settings/finantial-settings/finantial-settings-store';

export default {
    routes,
    store
};
